// @ts-nocheck
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formikinitialvalues, formikValidation, replaceUnderscore } from "../../../../../CommonFunction/common";
import Input from "../../../../Components/Input/Input";
import {
  CheckfieldExistornot,
  CheckTypeofInput,
  validationAdditional,
} from "../../../FormInputSectionComponent/formUtils";
import "./UserDetails.scss";
import { parseTheAdditionInfo } from "../../../../CommonFunction/parseTheAdditionInfo";
import { Formik_Vschema } from "../../../FormInputSectionComponent/Validation";

const MainUserDetails = ({
  inputfields,
  fielddata,
  Type,
  formkey,
  handleErrorsChange,
  formRef,
  TypeOfPortal,
  onhandleFormikChange,
  allFieldsData,
  setFirstLoad = () => {},
}) => {
  // eslint-disable-next-line
  const prevErrorsRef = useRef();
  const [fields, setfields] = useState(inputfields);
  const [userType, setUserType] = useState({});
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const Form_data1 = useSelector((store: any) => store.FormDataReducer.MasterData);

  const [consignorDetails, setConsignorDetails] = useState({
    GST_Number: "",
    Business_City: "",
    Business_Address: "",
  });

  const [consigneeDetails, setConsigneeDetails] = useState({
    GST_Number: "",
    Business_City: "",
    Business_Address: "",
  });

  const [businessDetailsconsignorDetails, setBusinessDetailsconsignorDetails] = useState({
    GST_Number: "",
    Business_City: "",
    Business_Address: "",
  });

  ///////////////////////////////////////////////////////////////////////

  const formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: Formik_Vschema(fields),
    enableReinitialize: true,
    validateOnChange: true,

    onSubmit: (values, { resetForm }) => {},
  });

  useEffect(() => {
    setfields(validationAdditional(inputfields));
  }, [inputfields]);

  useEffect(() => {
    if (formRef && Type) {
      formRef.current[Type] = {
        submitForm: formik.submitForm,
        resetForm: (InpType) => {
          if (InpType) {
            const filteredFields = CheckTypeofInput(fields, InpType);

            filteredFields?.forEach((field) => {
              if (field?.name) {
                formRef.current?.[Type]?.updateSingleField(field.name, null);
              }
            });
          } else formik.resetForm();
        },
        updateForm: (newValues) => {
          let arr = [];
          for (let a = 0; a < fields?.length; a++) {
            if (fields[a].name === "Sidebyside") {
              for (let b = 0; b < fields[a].Subfields.length; b++) {
                const subfield = fields[a].Subfields[b];
                let fieldValue = newValues[subfield.name] || (subfield.type === "checkbox" ? false : null);
                arr.push({ [subfield.name]: fieldValue });
              }
            } else {
              let fieldValue = newValues[fields[a].name] ?? (fields[a].type === "checkbox" ? false : null);
              arr.push({ [fields[a].name]: fieldValue });
            }
          }

          const obj = arr.reduce((acc, cur) => ({ ...acc, ...cur }), {});
          formik.setValues({ ...formik.values, ...obj });
        },
        updateSingleField: (name, value) => {
          let fieldExists = CheckfieldExistornot(fields, name);

          if (fieldExists) {
            formik.setFieldValue(name, value);
          } else {
            console.warn(`Field with name "${name}" does not exist in the fields array.`);
          }
        },

        formclearFields: (InpType) => {},
        values: formik.values,
      };
    }

    return () => {};
  }, [formRef, Type, formik]);

  useEffect(() => {
    if (prevErrorsRef.current !== formik.errors) {
      const Err_Type = Type;
      const errors = { [Err_Type]: formik.errors };
      handleErrorsChange(errors);
      prevErrorsRef.current = formik.errors;
    }
  }, [formik.errors, handleErrorsChange, Type, formik.values]);

  useEffect(() => {
    const values = { [Type]: formik.values };
    onhandleFormikChange(formik.values);
    formik.validateForm();
  }, [formik.values, Type]);
  /////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (Form_data1?.[formkey]?.Consignor) {
      setConsignorDetails({
        GST_Number: Form_data1?.[formkey]?.Consignor?.GST_Number,
        Business_City: Form_data1?.[formkey]?.Consignor?.Business_City,
        Business_Address: Form_data1?.[formkey]?.Consignor?.Business_Address,
      });
    } else {
      setConsignorDetails({
        GST_Number: "",
        Business_City: "",
        Business_Address: "",
      });
    }
    if (Form_data1?.[formkey]?.Consignee) {
      setConsigneeDetails({
        GST_Number: Form_data1?.[formkey]?.Consignee?.GST_Number,
        Business_City: Form_data1?.[formkey]?.Consignee?.Business_City,
        Business_Address: Form_data1?.[formkey]?.Consignee?.Business_Address,
      });
    } else {
      setConsigneeDetails({
        GST_Number: "",
        Business_City: "",
        Business_Address: "",
      });
    }
    if (Form_data1?.[formkey]?.Bill_Consignor) {
      setBusinessDetailsconsignorDetails({
        GST_Number: Form_data1?.[formkey]?.Bill_Consignor?.GST_Number,
        Business_City: Form_data1?.[formkey]?.Bill_Consignor?.Business_City,
        Business_Address: Form_data1?.[formkey]?.Bill_Consignor?.Business_Address,
      });
    } else {
      setBusinessDetailsconsignorDetails({
        GST_Number: "",
        Business_City: "",
        Business_Address: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Form_data1]);

  const determineVisibility = (field) => {
    if (field.header && field.name === "Pincode") {
      setUserType(field.header);
    }
    if (field.dependOn) {
      const { section, name, visibleOn } = field.dependOn;

      if (formRef.current[section]?.values[name] === visibleOn) {
        return true;
      } else if (formRef.current[section]?.values[name]) {
        if (formik.errors?.[field.name]) {
          delete formik.errors[field.name];
        }
        let key = field.name;
        if (formik.values[key]) {
          formik.setFieldValue(key, "");
          if (field?.type === "InputDropForQuery") {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: formkey,
                data: {
                  [field.name]: "",
                },
              },
            });
          }
        }
        return false;
      } else if (FormData?.[name] === visibleOn) {
        return true;
      }
      if (formik.errors?.[field.name]) {
        delete formik.errors[field.name];
      }
      return false;
    }

    return true; // Fields without a dependOn property are always visible
  };

  const determineDisability = (field) => {
    if (field?.disableDependOn) {
      const { section, name, disableOn, value, disableOnValue } = field.disableDependOn;

      const dependentSection =
        FormDataFromRedux?.MasterData?.[formkey]?.[name]?.[disableOn] || formRef.current?.[section]?.values[name];
      if (dependentSection !== null && dependentSection !== undefined && disableOnValue !== dependentSection) {
        return { ...field, disabled: false };
      } else {
        let key = field.name;
        if (value && formik.values[key] !== value) {
          formik.setFieldValue(key, value);
        }

        return { ...field, disabled: true };
      }
    }
    return field;
  };

  return (
    <div>
      <div className="headingaddloadsection5">{replaceUnderscore(Type)}</div>
      <div className="AccountDetailsBox">
        <div className="AccountData">
          {fields.map((element) => {
            let parseData;
            if (element.Additional_Info && element.Additional_Info.trim()) {
              parseData = parseTheAdditionInfo(element);
            } else {
              parseData = element;
            }
            if (!determineVisibility(parseData)) {
              return null;
            }
            let el = determineDisability(parseData);
            return (
              <>
                {el.name === "Consignee" ||
                el.name === "Consignor" ||
                el.name === "Bill_Consignor" ||
                el.name === "Bill_Consignor_Person" ||
                el.name === "Consignor_Person" ||
                el.name === "Consignee_Person" ? (
                  <div className="InputDrop">
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={el}
                      name={el.name}
                      value={formik.values[el.name]}
                      label={el.label}
                      type={el.type}
                      modalform={true}
                      Iconinside={true}
                      handleInputChange={(evt) => {
                        setFirstLoad((curr) => {
                          return curr || true;
                        });
                        formik.handleChange(evt);
                      }}
                      disabled={el.disabled}
                      handleBlur={formik.handleBlur}
                      error={formik.errors[el.name]}
                      dropdowndata={el.dropdowncontent || el.dropdowndata}
                      hasApiCallback={el.hasApiCallback}
                      min={el.min}
                      max={el.max ? el.max : undefined}
                      formkey={formkey}
                      TypeOfPortal={TypeOfPortal}
                      fielddata={fielddata}
                    />
                    {(el.name === "Consignor" || el.name === "Consignee" || el.name === "Bill_Consignor") && (
                      <>
                        <p>
                          {`GST No. : ${
                            el.name === "Consignor"
                              ? consignorDetails?.GST_Number
                                ? consignorDetails?.GST_Number
                                : ""
                              : el.name === "Consignee"
                              ? consigneeDetails?.GST_Number
                                ? consigneeDetails?.GST_Number
                                : ""
                              : el.name === "Bill_Consignor"
                              ? businessDetailsconsignorDetails?.GST_Number
                                ? businessDetailsconsignorDetails?.GST_Number
                                : ""
                              : ""
                          }`}
                        </p>
                        <p>{`City : ${
                          el.name === "Consignor"
                            ? consignorDetails?.Business_City
                              ? consignorDetails?.Business_City
                              : ""
                            : el.name === "Consignee"
                            ? consigneeDetails?.Business_City
                              ? consigneeDetails?.Business_City
                              : ""
                            : el.name === "Bill_Consignor"
                            ? businessDetailsconsignorDetails?.Business_City
                              ? businessDetailsconsignorDetails?.Business_City
                              : ""
                            : ""
                        }`}</p>
                        <p>{`Address : ${
                          el.name === "Consignor"
                            ? consignorDetails?.Business_Address
                              ? consignorDetails?.Business_Address
                              : ""
                            : el.name === "Consignee"
                            ? consigneeDetails?.Business_Address
                              ? consigneeDetails?.Business_Address
                              : ""
                            : el.name === "Bill_Consignor"
                            ? businessDetailsconsignorDetails?.Business_Address
                              ? businessDetailsconsignorDetails?.Business_Address
                              : ""
                            : ""
                        }`}</p>
                      </>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MainUserDetails;

{
  /* <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={el}
                      formkey={formkey}
                      JurnalDropdown=""
                      Section_Type=""
                      disabled=""
                      transactions=""
                      PaymentProcess=""
                      TypeOfPortal={""}
                      name={el.name}
                      value={formik.values?.[el.name]}
                      label={el.label}
                      className={""}
                      type={"InputDropForQuery"}
                      modalform={true}
                      handleInputChange={(evt) => {
                        formik.handleChange(evt);
                      }}
                      handleBlur={formik.handleBlur}
                      touched={formik.touched[el.name]}
                      error={formik.errors[el.name]}
                      max={el.max ? el.max : undefined}
                      notSearchable={el.name === "From_City" || el.name === "To_City" ? true : false}
                    /> */
}
// const validate = (values: any) => {
//   setalldata({ ...values });
// };

// const formik = useFormik({
//   initialValues: () => {
//     let initialstate = formikinitialvalues(fields);
//     return initialstate;
//   },
//   validationSchema: formikValidation(fields),
//   validate,
//   onSubmit: (values) => {},
// });

// useEffect(() => {
//   const values = { [Type]: formik.values };
//   onhandleFormikChange(formik.values);
//   formik.validateForm();
// }, [formik.values, Type]);

// useEffect(() => {
//   if (formRef && Type) {
//     formRef.current[Type] = {
//       submitForm: formik.submitForm,
//       resetForm: formik.resetForm,
//       updateForm: (newValues) => {
//         console.log(newValues, fields);
//         let arr = [];
//         for (let a = 0; a < fields?.length; a++) {
//           if (fields[a].name === "Sidebyside") {
//             for (let b = 0; b < fields[a].Subfields.length; b++) {
//               const subfield = fields[a].Subfields[b];
//               let fieldValue = newValues[subfield.name] || (subfield.type === "checkbox" ? false : null);
//               arr.push({ [subfield.name]: fieldValue });
//             }
//           } else {
//             let fieldValue = newValues[fields[a].name] || (fields[a].type === "checkbox" ? false : null);
//             arr.push({ [fields[a].name]: fieldValue });
//           }
//         }

//         const obj = arr.reduce((acc, cur) => ({ ...acc, ...cur }), {});
//         formik.setValues({ ...formik.values, ...obj });
//       },
//       updateSingleField: (name, value) => {
//         let fieldExists = CheckfieldExistornot(fields, name);
//         // Update the field value only if it exists
//         if (fieldExists) {
//           formik.setFieldValue(name, value);
//         } else {
//           console.warn(`Field with name "${name}" does not exist in the fields array.`);
//         }
//       },
//       values: formik.values,
//     };
//   }

//   return () => {
//     if (formRef && Type) {
//       delete formRef.current[Type];
//     }
//   };
// }, [formRef, Type, formik]);
